<form>
  <div fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="400px" [formGroup]="editForm">
      <mat-card appearance="outlined" class="password-reset-card">
        <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
          <h3 mat-dialog-title>{{ 'パスワード再設定' | translate }}</h3>
          <mat-form-field>
            <mat-label>{{ 'メールアドレス' | translate }}</mat-label>
            <input matInput type="admin_id" placeholder="{{ 'メールアドレス' | translate }}" id="admin_id" formControlName="admin_id" autocomplete="off" required>
            <mat-error *ngIf="adminIdControl.invalid">{{ getErrorMessageToAdminId() }}</mat-error>
          </mat-form-field>
          <div fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
            <button mat-button color="accent" routerLink="/sign-in" cdkFocusInitial><mat-icon class="mat-icon-event-btn">reply</mat-icon>ログインへ</button>
            <button mat-button color="primary" (click)="passwordReset()" [disabled]="editForm.invalid"><mat-icon class="mat-icon-event-btn">account_circle</mat-icon>{{ 'メール送信' | translate }}</button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</form>
